export default __webpack_public_path__ + "static/media/jacobKendall.3d2cbe1f.jpeg";